import {observable, computed, action, autorun, runInAction, toJS} from 'mobx';
import {getIn, genGuid} from '../utils';
import createSelector, {LruCacheObject} from 're-reselect';
import * as constants from './const';

class RentalTransactionOffer {
  @observable content;

  constructor(content) {
    this.content = content;
  }

  @computed get id() {
    return this.content.Id;
  }

  @computed get rentalObjectId() {
    return this.content.refRentalObjectId;
  }

  @computed get name() {
    return this.content.Name;
  }

  @computed get price() {
    return getIn(this.content, ['TotalPrice']);
  }

  @computed get quantity() {
    return getIn(this.content, ['OfferQuantity']);
  }

  @computed get isOfMainObject() {
    return !getIn(this.content, ['refRentalTransactionAccessoryId']);
  }

  @computed get prolongationOfferQuantity() {
    return getIn(this.content, ['ProlongationOfferQuantity']);
  }

  @computed get prolongationTUQuantity() {
    return getIn(this.content, ['ProlongationTimeUnitQuantity']);
  }  

  @computed get prolongationOfferPrice() {
    return getIn(this.content, ['ProlongationOfferPrice']);
  }   
  
  @computed get prolongationPrice() {
    return getIn(this.content, ['ProlongationPrice']);
  } 
  
  @computed get prolongationName() {
    return getIn(this.content, ['ProlongationName']);
  }    
  /*deleter() {
    return {
      RentalTransactionAccessoriesOfferSelectable: {
        RentalTransactionOfferSelectable: {
          Id: this.id,
        }
      } 
    } 
  }*/

  deleterItem() {
    return {
      Id: this.id, 
    } 
  }


}

class RentalTransactionService {
  @observable content;

  constructor(content) {
    this.content = content;
  }

  @computed get id() {
    return this.content.Id;
  }
 
  @computed get idRentalService() {
    return this.content.refRentalServiceId;
  }

  @computed get name() {
    return this.content.Name; 
  }

  @computed get price() {
    //return getIn(this.content, ['TotalPrice']);
    return getIn(this.content, ['ResultPrice']);
  }
}

class RentalTransactionAccessory {
  @observable content;

  constructor(content) {
    this.content = content;
  }

  @computed get name() {
    return getIn(this.content, ['Name']);
  }

  @computed get id() {
    return getIn(this.content, ['refRentalObjectId']);
  }

  @computed get refRentalObjectId() {
    return getIn(this.content, ['refRentalObjectId']);
  }

  @computed get idRentalTransaction() {
    return getIn(this.content, ['Id']);
  }

  @computed get quantity() {
    return getIn(this.content, ['Quantity'])
  }

  @computed get sumTotalPrice() {
    return getIn(this.content, ['SumTotalPrice']);
  }

  deleter() {
    return toJS(this.content.offer);
  }
}

export class CustomerAddress {
  constructor(content) {
    this._content = content || {};
  }

  static newFromValues({typeId, street, addition, postalCode, city, country}) {
    let addr = new CustomerAddress();
    addr.setNewValues({typeId, street, addition, postalCode, city, country})
    addr._content.Id = genGuid();
    return addr;
  }

  @action.bound setNewValues({id, typeId, street, addition, postalCode, city, country}) {
    this._content = {
      refAddressTypeId: typeId || this.refAddressTypeId, 
      Id: id || this.id,
      Street: street,
      AddressAddition: addition,
      PostalCode: postalCode,
      City: city,
      refCountryId: country,
    };
  }

  @computed get id() {
    return getIn(this._content, ['Id']);
  }

  @computed get refAddressTypeId() {
    return getIn(this._content, ['refAddressTypeId']);
  }

  @computed get values() {
    return toJS(this._content);
    return {
      Id: getIn(this._content, ['Id']),
      Street: getIn(this._content, ['Street']),
      Addressddition: getIn(this._content, ['AddressAddition']),
      PostalCode: getIn(this._content, ['PostalCode']),
      City: getIn(this._content, ['City']),
      refCountryId: getIn(this._content, ['refCountryId']),
      refAddressTypeId: getIn(this._content, ['refAddressTypeId']),
    }
  }

}

export class RentalTransaction {
  @observable content = {};

  constructor(api) {
    this.api = api;
  }

  @computed get id() {
    return getIn(this.content, ['RentalTransaction', 0, 'Id']);
  }

  @computed get refRentalObjectId() {
    return getIn(this.content, ['RentalTransaction', 0, 'refRentalObjectId']);
  }

  @computed get name() {
    return getIn(this.content, ['RentalTransaction', 0, 'Name']);
  }

  @computed get totalPrice() {
    return getIn(this.content, ['RentalTransaction', 0, 'TotalPrice']);
  }

  @computed get rentalFeeDiscountName() {
    return getIn(this.content, ['RentalTransaction', 0, 'RentalFeeDiscountName']);
  }
  
  @computed get serviceDiscountName() {
    return getIn(this.content, ['RentalTransaction', 0, 'ServiceDiscountName']);
  }

  @computed get consumablesDiscountName() {
    return getIn(this.content, ['RentalTransaction', 0, 'ConsumablesDiscountName']);
  }

  @computed get totalDiscount() {
    return getIn(this.content, ['RentalTransaction', 0, 'TotalDiscountPrice']);
  }  

  @computed get discountRate() {
    return getIn(this.content, ['RentalTransaction', 0, 'RentalFeeDiscountRate']);
  }  

  @computed get normServiceDiscount() {
    return getIn(this.content, ['RentalTransaction', 0, 'NormServiceDiscountPrice']);
  }    

  @computed get consumableDiscountPrice() {
    return getIn(this.content, ['RentalTransaction', 0, 'ConsumableDiscountPrice']);
  }

  @computed get totalDiscountedPrice() {
    return getIn(this.content, ['RentalTransaction', 0, 'TotalDiscountedPrice']);
  }  

  @computed get voucherCode() {
    return getIn(this.content, ['RentalTransaction', 0, 'VoucherCode']);
  }  
  
  @computed get voucherPrice() {
    return getIn(this.content, ['RentalTransaction', 0, 'VoucherPrice']);
  }    

  @computed get rentingStartDate() {
    return getIn(this.content, ['RentalTransaction', 0, 'PickupStartDate']);
  }

  @computed get rentingEndDate() {
    return getIn(this.content, ['RentalTransaction', 0, 'DropoffEndDate']);
  }    

  @computed get realRentingStartDate() {
    return getIn(this.content, ['RentalTransaction', 0, 'RentingStartDate']);
  }

  @computed get realRentingEndDate() {
    return getIn(this.content, ['RentalTransaction', 0, 'RentingEndDate']);
  }

  @computed get deposit() {
    return getIn(this.content, ['RentalTransaction', 0, 'Deposit']);
  }

  @computed get extrasPrice() {
    return this.totalPrice && this.firstOffer.price && this.totalPrice - this.firstOffer.price;
  }

  @computed get offers() {
    return getIn(this.content, ['RentalTransaction', 0, 'RentalTransactionOffer'], []).map(o => {
      return new RentalTransactionOffer(o);
    })
  }

  @computed get mainObjectOffers() {
    return this.offers.filter(o => o.isOfMainObject);
  }
 
  @computed get services() {
    return getIn(this.content, ['RentalTransaction', 0, 'RentalTransactionService'], []).map(o => {
      return new RentalTransactionService(o);
    })    
  }

  @computed get accessories() {
    return getIn(this.content, ['RentalTransaction', 0, 'RentalTransactionAccessory'], []).map(o => {
      return new RentalTransactionAccessory(o);
    })
  }

  @computed get addresses() {
    return getIn(this.content, ['RentalTransaction', 0, 'RentalTransactionCustomerAddress'], []).map(o => {
      return new CustomerAddress(o);
    });
  }

  serviceByServiceId(id) {
    return this.services.find(o => o.idRentalService === id);
  }

  accessoryById(id) {
    return this.accessories.find(o => o.id === id);
  }

  // TODO: Get rid of this...
  @computed get firstOffer() {
    return getIn(this.offers, [0], {});
  }

  offerByRentalObjectId(id) {
    return this.offers.find(o => o.rentalObjectId === id);
  }

  offerDeleter(deleterList) {
    return {
      RentalTransactionOfferSelectable: deleterList
    }
  }  

  @action async begin({orgId, duration, startDate, objId, timeUnit}) {
    if(this._loadingPromise) {
      return this._loadingPromise;
    }
    try {
      this.content = {};
      this._loadingPromise = this.api.updateRentalTransaction({
        organizationId: orgId, 
        duration, 
        startDate, 
        objectId: objId, 
        timeUnitId: timeUnit,
      })
      let content = await this._loadingPromise;
      this.content = content;
    }    
    finally {
      this._loadingPromise = undefined;
    }
  }  

  @action async fetch({orgId, trxId}) {    
    if(this._loadingPromise) {
      return this._loadingPromise;
    }
    if(trxId === undefined) {
      return
    }      
    try {
      this.content = {};
      this._loadingPromise = this.api.getRentalTransaction({
        organizationId: orgId,
        transactionId: trxId,
      });
      this.content = await this._loadingPromise;
    }
    finally {
      this._loadingPromise = undefined;
    }
  }

  cFetch = createSelector(
    [p => p],
    (p) => this.fetch(p)
  )(
    ({orgId, trxId}) => 
      `${orgId}@${trxId}`,
    {cacheObject: new LruCacheObject({cacheSize: 1}), }
  );    

  @action async deleteOffer({orgId, trxId, deleter}) {
    if(this._loadingPromise) {
      return this._loadingPromise;
    } 
    if(trxId === undefined) {
      return
    }      
    try {
      this.content = await (this._loadingPromise = this.api.deleteRentalTransactionOffer({
        organizationId: orgId,
        transactionId: trxId,
        deleter
      }));
    }
    finally {
      this._loadingPromise = undefined;
    }
  }

  @action async addOffer({orgId, trxId, updater}) {
    if(this._loadingPromise) {
      return this._loadingPromise;
    }
    if(trxId === undefined) {
      return
    }      
    try {
      this.content = await (this._loadingPromise = this.api.updateRentalTransactionOffers({
        organizationId: orgId,
        transactionId: trxId,
        updater
      }));
    }
    finally {
      this._loadingPromise = undefined;
    }    
  }

  @action async addService({orgId, trxId, id}) {
    if(trxId === undefined) {
      return
    }      
    this.content = await this.api.addRentalService({
      organizationId: orgId,
      transactionId: trxId,
      rentalServiceId: id, 
      rentalTransactionAccessoryId: undefined,
    })
  }

  @action async deleteService({orgId, trxId, id}) {     
    this.content = await this.api.removeRentalService({
      organizationId: orgId,
      transactionId: trxId,
      rentalTransactionServiceId: id, 
    })
  }

  @action async addAccessory({orgId, trxId, updater}) {
    await this.addOffer({orgId, trxId, updater});
  }

  @action async deleteAccessory({orgId, trxId, id}) {
    if(trxId === undefined) {
      return
    }      
    this.content = await this.api.deleteRentalTransactionOffer({
      organizationId: orgId,
      transactionId:trxId,
      deleter: {
        RentalTransactionAccessoriesOfferSelectable: [{
          Id: id
        }],
        RentalTransactionOfferSelectable: [],
      }
    })
  }

  @action async setAccessoryQuantity({trxId, id, quantity}) {
    if(trxId === undefined) {
      return
    }      
    this.content = await this.api.setAccessoryQuantity({
      transactionId: trxId,
      rentalTransactionAccessoryId: id,
      quantity,
    })
  }

  @action.bound async setCurrentUserAsLessee({orgId, trxId}) {
    if(trxId === undefined) {
      return
    }      
    this.content = await this.api.setCurrentUserAsLessee({
      organizationId: orgId, 
      transactionId: trxId,       
    })
  }

  @action.bound async setGuestData({orgId, trxId, personalDataValues, personalAddressesValues}) {
    if(trxId === undefined) {
      return
    }      
    const personalData = this.api.makeOBP({
      Email: personalDataValues.email, 
      FirstName: personalDataValues.firstName, 
      Name: personalDataValues.lastName, 
      Phone: personalDataValues.phone, 
      Mobile: personalDataValues.mobilePhone,
      refSalutationId: personalDataValues.salutation,       
    });

    const addressMakers = personalAddressesValues
    .filter(o => {
      return o.street && o.postalCode && o.country && o.city;
    })
    .map(o => this.api.makeAddress({
      AddressName: personalDataValues.organization,
      AddressAddition: o.addition,
      City: o.city, 
      PostalCode: o.postalCode, 
      Street: o.street, 
      refAddressTypeId: o.refAddressTypeId, 
      refCountryId: o.country,      
    }));

    this.content = await this.api.setGuestData({
      organizationId: orgId, 
      transactionId: trxId, 
      address1: addressMakers[0], 
      address2: addressMakers[1], 
      address3: addressMakers[2],  
      obp: personalData,
    }) 
  }

  @action.bound async editAddresses(addresses) {
    let trxAddresses = [...this.addresses];
    let newAddresses = [];
    for(let newAddr of addresses) {
      let trxCpAddr = trxAddresses.find(o => o.refAddressTypeId === newAddr.refAddressTypeId);
      if(trxCpAddr) {
        trxCpAddr.setNewValues({...newAddr, id: trxCpAddr.id});
        newAddresses.push(trxCpAddr);
      } else {
        newAddresses.push(CustomerAddress.newFromValues(newAddr));
      }
    }
    if(newAddresses.length > 0) {
      this.content = await this.api.editAddresses(this.id, [...newAddresses]);
    }
  }

  @action.bound async checkVoucherCode({trxId, code}) {
    this.content = await this.api.checkVoucherCode({trxId, code});
  }

  @action.bound async doBook({orgId, trxId, bookingNote, bookingNote2, paymentMethodId}) {   
    return await this.api.book({
      organizationId: orgId, 
      transactionId: trxId, 
      bookingNote, 
      bookingNote2, 
      paymentMethodId, 
      dataTransReturnLocation: '',
    })
  }

  @action.bound async doReserve({orgId, trxId, bookingNote, bookingNote2, paymentMethodId}) {     
    return await this.api.reserve({
      organizationId: orgId, 
      transactionId: trxId, 
      bookingNote, 
      bookingNote2, 
      paymentMethodId
    });
  }

  @action.bound async confirmSelection({orgId, trxId}) {
    if(trxId === undefined) {
      return
    }      
    this.content = await this.api.confirmSelection({
      organizationId: orgId, 
      transactionId: trxId,       
    });
  }
}


// WEBPACK FOOTER //
// ./src/model/RentalTransaction.js